<div>
    <mat-paginator *ngIf="paginator" #paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]" [length]="contactservice.dataLength" (page)="changePage($event)"></mat-paginator>
    <table mat-table matSort [dataSource]="contacts" class="contact-table">
        <ng-container matColumnDef="contact">
            <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
            <td mat-cell *matCellDef="let contact">
                <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                    <div fxFlex="grow">
                        <app-contact-row [item]="contact"></app-contact-row>
                    </div>
                    <div fxFlex="40%">
                        <app-contact-row-prescription [item]="contact"></app-contact-row-prescription>
                    </div>
                    <div fxFlex="82px">
                        <app-contact-documents-row *ngIf="contact.haveContactDocument" [contact]="contact"></app-contact-documents-row>
                    </div>
                    <div fxFlex="10%">
                        <app-contact-services-row *ngIf="contact.haveContactService" [contact]="contact"></app-contact-services-row>
                    </div>
                    <div fxFlex="10%">
                        <div class="user-info">
                            <div style="width:100px;overflow-x: hidden;white-space:nowrap;font-size:75%;">{{ getCreatedDate(contact) }}</div>
                            <div style="width:100px;overflow-x: hidden;white-space:nowrap;font-size:75%;">{{ getCreator(contact) }}</div>
                        </div>
                    </div>
                </div>
                <div></div>
            </td>
        </ng-container>
        <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
